<template>
  <div>
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <ScoutApplicantsBar />
          </div>
          <!-- ends client-listing-head -->
        </div>
      </div>
      <!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container">
          <div class="client-listing-detail">
            <ScoutApplicantsList />
          </div>
          <!-- ends client-listing-detail -->
        </div>
      </div>
      <!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import ScoutApplicantsList from '@/components/dashboard/scoutApplicants/ScoutApplicantsList.vue';
import ScoutApplicantsBar from '@/components/dashboard/scoutApplicants/ScoutApplicantsBar.vue';
// import CategoryList from '@/components/dashboard/category/CategoryList.vue';
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'ScoutApplicants',
  components: { ScoutApplicantsList, ScoutApplicantsBar },
  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
    }),
  },
  mounted() {
    this.changeBodyBackground();
  },
  methods: {
    ...mapMutations({
      setStatusModel: 'setStatusModel',
      setProfileModalState: 'setProfileModalState',
      resetApplicantListState: 'resetApplicantListState',
      setScoutTypeModel: 'setScoutTypeModel',
      setScoutedBy: 'setScoutedBy',
    }),
  },
  beforeRouteLeave(to, from, next) {
    this.resetApplicantListState();
    this.setStatusModel([]);
    this.setScoutTypeModel([]);
    this.setScoutedBy(null);
    this.setProfileModalState(false);
    next();
  },
};
</script>
